export const COUNTRY_PREFIXES = [
    { code: '+34', name: '🇪🇸 +34' },
    { code: '+33', name: '🇫🇷 +33' },
    { code: '+49', name: '🇩🇪 +49' },
    { code: '+351', name: '🇵🇹 +351' },
    { code: '+44', name: '🇬🇧 +44' },
    { code: '+1', name: '🇺🇸 +1' },
    { code: '+39', name: '🇮🇹 +39' },
    { code: '+31', name: '🇳🇱 +31' },
    { code: '+32', name: '🇧🇪 +32' },
    { code: '+355', name: '🇦🇱 +355' },
    { code: '+213', name: '🇩🇿 +213' },
    { code: '+376', name: '🇦🇩 +376' },
    { code: '+244', name: '🇦🇴 +244' },
    { code: '+1264', name: '🇦🇮 +1264' },
    { code: '+1268', name: '🇦🇬 +1268' },
    { code: '+54', name: '🇦🇷 +54' },
    { code: '+374', name: '🇦🇲 +374' },
    { code: '+297', name: '🇦🇼 +297' },
    { code: '+61', name: '🇦🇺 +61' },
    { code: '+43', name: '🇦🇹 +43' },
    { code: '+994', name: '🇦🇿 +994' },
    { code: '+1242', name: '🇧🇸 +1242' },
    { code: '+973', name: '🇧🇭 +973' },
    { code: '+880', name: '🇧🇩 +880' },
    { code: '+1246', name: '🇧🇧 +1246' },
    { code: '+375', name: '🇧🇾 +375' },
    { code: '+501', name: '🇧🇿 +501' },
    { code: '+229', name: '🇧🇯 +229' },
    { code: '+1441', name: '🇧🇲 +1441' },
    { code: '+975', name: '🇧🇹 +975' },
    { code: '+591', name: '🇧🇴 +591' },
    { code: '+387', name: '🇧🇦 +387' },
    { code: '+267', name: '🇧🇼 +267' },
    { code: '+55', name: '🇧🇷 +55' },
    { code: '+673', name: '🇧🇳 +673' },
    { code: '+359', name: '🇧🇬 +359' },
    { code: '+238', name: '🇨🇻 +238' },
    { code: '+1345', name: '🇰🇾 +1345' },
    { code: '+56', name: '🇨🇱 +56' },
    { code: '+86', name: '🇨🇳 +86' },
    { code: '+57', name: '🇨🇴 +57' },
    { code: '+506', name: '🇨🇷 +506' },
    { code: '+53', name: '🇨🇺 +53' },
    { code: '+357', name: '🇨🇾 +357' },
    { code: '+420', name: '🇨🇿 +420' },
    { code: '+45', name: '🇩🇰 +45' },
    { code: '+1809', name: '🇩🇴 +1809' },
    { code: '+593', name: '🇪🇨 +593' },
    { code: '+20', name: '🇪🇬 +20' },
    { code: '+503', name: '🇸🇻 +503' },
    { code: '+372', name: '🇪🇪 +372' },
    { code: '+358', name: '🇫🇮 +358' },
    { code: '+995', name: '🇬🇪 +995' },
    { code: '+30', name: '🇬🇷 +30' },
    { code: '+502', name: '🇬🇹 +502' },
    { code: '+504', name: '🇭🇳 +504' },
    { code: '+852', name: '🇭🇰 +852' },
    { code: '+36', name: '🇭🇺 +36' },
    { code: '+354', name: '🇮🇸 +354' },
    { code: '+91', name: '🇮🇳 +91' },
    { code: '+62', name: '🇮🇩 +62' },
    { code: '+98', name: '🇮🇷 +98' },
    { code: '+353', name: '🇮🇪 +353' },
    { code: '+972', name: '🇮🇱 +972' },
    { code: '+81', name: '🇯🇵 +81' },
    { code: '+82', name: '🇰🇷 +82' },
    { code: '+371', name: '🇱🇻 +371' },
    { code: '+370', name: '🇱🇹 +370' },
    { code: '+352', name: '🇱🇺 +352' },
    { code: '+60', name: '🇲🇾 +60' },
    { code: '+52', name: '🇲🇽 +52' },
    { code: '+373', name: '🇲🇩 +373' },
    { code: '+64', name: '🇳🇿 +64' },
    { code: '+505', name: '🇳🇮 +505' },
    { code: '+47', name: '🇳🇴 +47' },
    { code: '+507', name: '🇵🇦 +507' },
    { code: '+595', name: '🇵🇾 +595' },
    { code: '+51', name: '🇵🇪 +51' },
    { code: '+48', name: '🇵🇱 +48' },
    { code: '+40', name: '🇷🇴 +40' },
    { code: '+7', name: '🇷🇺 +7' },
    { code: '+46', name: '🇸🇪 +46' },
    { code: '+41', name: '🇨🇭 +41' },
    { code: '+66', name: '🇹🇭 +66' },
    { code: '+90', name: '🇹🇷 +90' },
    { code: '+380', name: '🇺🇦 +380' },
    { code: '+598', name: '🇺🇾 +598' },
    { code: '+58', name: '🇻🇪 +58' }
];